import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'
import { composeStyle } from '@xhs/yam-beer/core/system/compose'

const errorState = '&[data-error]'
const disabledState = '&:not([data-error])[disabled]'
const activeState = '&:not([disabled]):not([data-error])[data-active], &:not([disabled]):not([data-error]):focus'
const hoverState = '&:not([disabled]):not([data-error]):not([data-active]):not(:focus):hover, &:not([disabled]):not([data-error]):not(:focus)[data-hover]'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.textarea', {
      wrapper: {
        position: 'relative',
        display: 'inline-block',
        width: '400px',
      },
      input: {
        textRendering: 'unset',
        fontFamily: 'default',
        appearance: 'none',
        outline: 'none',
        p: '5px 12px',

        boxSizing: 'border-box',
        fontSize: '14px',
        lineHeight: '22px',
        verticalAlign: 'middle',
        color: 'body',
        caretColor: 'brand',
        border: composeStyle.when('bordered')
          .truthy('outlineoutline')
          .falsy('none'),
        borderRadius: 'control',
        width: '100%',
        resize: 'vertical',

        bg: 'unset',
        '&::placeholder': {
          color: 'ash',
        },

        [errorState]: {
          borderColor: 'palette.danger.base',
        },
        [hoverState]: {
          borderColor: 'palette.outline.hover',
        },
        [activeState]: {
          borderColor: 'palette.brand.base',
        },
        [disabledState]: {
          cursor: 'not-allowed',
          bg: '#fbfbfb',
        },
      },
    }),
  ]
}
